import { useState, useEffect } from 'react';
import SubmissionService from '../services/submissionService';

/**
 * React hook for managing submissions
 * Provides real-time updates from Firestore
 */
export const useSubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('useSubmissions: Setting up listener');
    setLoading(true);

    const unsubscribe = SubmissionService.listenToAllSubmissions((updatedSubmissions) => {
      console.log('useSubmissions: Received submissions:', updatedSubmissions.length);
      setSubmissions(updatedSubmissions);
      setLoading(false);
      setError(null);
    });

    return () => {
      console.log('useSubmissions: Cleaning up listener');
      unsubscribe();
    };
  }, []);

  return { submissions, loading, error };
};

/**
 * Hook for managing a single submission
 */
export const useSubmission = (campaignId, briefId, submissionId) => {
  const [submission, setSubmission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!campaignId || !briefId || !submissionId) {
      setLoading(false);
      return;
    }

    const fetchSubmission = async () => {
      try {
        setLoading(true);
        const data = await SubmissionService.getSubmission(campaignId, briefId, submissionId);
        setSubmission(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching submission:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSubmission();
  }, [campaignId, briefId, submissionId]);

  return { submission, loading, error };
};

export default useSubmissions;









